const BASE_SELECTOR: string = ".settings-top-bar__layouts";
const ICON_SELECTOR: string = 'svg';
const IS_ACTIVE_CLASSNAME: string = 'is-active';
const GRID_SELECTOR: string = "form[data-grid]";

export class LayoutSwitcherUI {
  public constructor(private $base: JQuery) {}

  public onIconClick(handleClick: (grid: number) => void) : void {
    this.$base.find(ICON_SELECTOR).on('click', (e) => {
      this.$base.find('svg').removeAttr('class');
      const grid = e.currentTarget.getAttribute('data-grid');
      e.currentTarget.classList.add(IS_ACTIVE_CLASSNAME);
      handleClick(Number(grid));
    });
  }

  public disableIcon(cols: number) : void {
    this.$base.find(`[data-grid='${cols}']`).addClass('is-disabled');
  }

  /*
  * Check if a section is available
  * @param maxGridValue: number - the method will search for a DOM Element with
  * this data-max-grid value
  */
  public isSectionAvailableByMaxGrid(maxGridValue: number) : boolean {
    if ($(document).find(`[data-max-grid="${maxGridValue}"]`).length > 0) {
      return true;
    }
    return false;
  }

  public setLayout(cols: Number) : void {
    $(GRID_SELECTOR).attr('data-grid', cols.toString());
    const icons = document.querySelectorAll(`.settings-top-bar__layouts [data-grid]`);
    const iconArray = Array.from(icons);
    iconArray.map((icon) => {
      if (icon.getAttribute('data-grid') === cols.toString()) {
        icon.classList.add(IS_ACTIVE_CLASSNAME);
      } else {
        icon.classList.remove(IS_ACTIVE_CLASSNAME);
      }
    })
  }
}

export function CreateLayoutSwitcherInstance() {
  const $base = $(BASE_SELECTOR);
  return [new LayoutSwitcherUI($base)]
}
